import { useEffect } from 'react';

/** Single Meta Pixel used across the whole landing page. */
export const META_PIXEL_ID = '28218651824502457';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      queue?: unknown[];
    };
    _fbq?: unknown;
    __metaPixelInitialized?: boolean;
  }
}

/** Fires a Meta Pixel event when the pixel is available. */
export function trackPixelEvent(event: string, params?: Record<string, unknown>): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return;
  window.fbq('track', event, params);
}

/**
 * Loads the Meta Pixel once and fires a single PageView.
 * Guarded so React re-renders / Strict Mode double effects never re-init the pixel
 * or send a second PageView.
 */
export function MetaPixel() {
  useEffect(() => {
    if (window.__metaPixelInitialized || document.getElementById('meta-pixel-script')) return;
    window.__metaPixelInitialized = true;
    const script = document.createElement('script');
    script.id = 'meta-pixel-script';
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${META_PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
  }, []);
  return null;
}